// Icons: Material Symbols (Apache-2.0), only the ones in use are bundled.
import arrowBack from '@material-symbols/svg-400/outlined/arrow_back.svg?raw';
import check from '@material-symbols/svg-400/outlined/check.svg?raw';
import close from '@material-symbols/svg-400/outlined/close.svg?raw';
import lock from '@material-symbols/svg-400/outlined/lock.svg?raw';
import moreVert from '@material-symbols/svg-400/outlined/more_vert.svg?raw';
import person from '@material-symbols/svg-400/outlined/person.svg?raw';
import visibility from '@material-symbols/svg-400/outlined/visibility.svg?raw';
import visibilityOff from '@material-symbols/svg-400/outlined/visibility_off.svg?raw';
import warning from '@material-symbols/svg-400/outlined/warning.svg?raw';

export const icons = { arrowBack, check, close, lock, moreVert, person, visibility, visibilityOff, warning };

export function Icon({ svg, size = 24, className }: { svg: string; size?: number; className?: string }) {
  return (
    <span
      className={className ? `icon ${className}` : 'icon'}
      style={{ width: size, height: size }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
